export default "__VITE_ASSET__5bf06bc3__$_?nuxt_component=async__"